export default {
   ALTERACOES: 1,
   ANISOCORIA: 2,
   ASSIMETRICA: 3,
   AUSENTE: 4,
   COM_LESOES: 5,
   ISOCORICAS: 6,
   LENTIFICADA: 7,
   MIDRIASE: 8,
   NORMAL: 9,
   OBSTRUCAO: 10,
   PRESENTE: 11,
   PERVEAS: 12,
   SEM_LESOES: 13,
   SIMETRICA: 14
}